import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  Header as TemplateHeader,
  SubHeading as TemplateSubHeading,
  Description as TemplateDescription,
} from "../Typography/typography.styled";
import { useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import heroScreenshotImageSrc from "../../images/hero-screenshot-1.png";

const PrimaryContainer = styled.div`
  background-color: ${(props) => props.backgroundColor};
`;

const ContainerXLPadding = styled(Container)`
  padding-bottom: 6rem;

  @media (min-width: 1024px) {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
`;

const Header = styled(TemplateHeader)`
  margin-top: 1rem;
  font-size: 1.875rem;
  line-height: 2.25rem;
  line-height: 2.5rem;
  font-weight: 900;
  letter-spacing: 0.025em;
  line-height: 1.25;
  text-align: left;
  text-align: center;
  color: rgb(36, 62, 99);

  @media (min-width: 640px) {
    font-size: 2.25rem;
    line-height: 2.5rem;
    line-height: 1;
  }
  @media (min-width: 768px) {
    text-align: left;
  }
  @media (min-width: 1024px) {
    font-size: 3rem;
    line-height: 3.5rem;
  }
`;

const Subheading = styled(TemplateSubHeading)`
  text-align: center;
  text-transform: uppercase;
  color: #6415ff;
  letter-spacing: 0.1rem;
  font-size: 1rem;
  margin-top: 4rem;

  @media (min-width: 768px) {
    text-align: left;
    margin-top: 0rem;
  }
`;

const Description = styled(TemplateDescription)`
  margin-top: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  line-height: 1.625;
  text-align: center;
  color: rgb(124, 139, 161);

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5rem;
    text-align: left;
  }
  @media (min-width: 1024px) {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`;

const TextContent = styled.div`
  text-align: center;

  @media (min-width: 768px) {
    margin-left: ${(props) => (props.textOnLeft ? "0rem" : "3rem")};
    margin-right: ${(props) => (props.textOnLeft ? "3rem" : "0rem")};
    text-align: start;
  }
  @media (min-width: 1024px) {
    margin-left: ${(props) => (props.textOnLeft ? "0rem" : "3rem")};
    margin-right: ${(props) => (props.textOnLeft ? "3rem" : "0rem")};
  }
`;

const ImageContent = styled.img`
  border: ${(props) => (props.imageBorder ? "2px solid #f4f4f4" : "none")};
`;

const TextColumn = styled(Col)`
  display: flex;
  align-items: start;

  @media (min-width: 720px) {
    align-items: center;
  }
`;

const PrimaryButton = styled(motion.button)`
  // Template
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 2rem;
  padding-right: 2rem;
  background-color: rgb(100, 21, 255);
  color: #f3f4f6;
  font-weight: 700;

  // Feature specific
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-radius: 5rem;
  text-decoration: none;
`;

const TwoColWithButton = ({
  subheading = "Quality Work",
  heading = (
    <>
      Designed & Developed by{" "}
      <span style={{ color: "#6415ff" }}>Professionals.</span>
    </>
  ),
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
  primaryButtonText = "Learn More",
  primaryButtonUrl = "https://timerse.com",
  buttonRounded = true,
  imageRounded = true,
  imageBorder = false,
  imageShadow = false,
  imageCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
  imageSrc = heroScreenshotImageSrc,
  textOnLeft = true,
  backgroundColor = "#ffffff",
  enableButton = true,
  additionals = {},
}) => {
  let history = useHistory();

  const handleClick = () => {
    history.push(`${primaryButtonUrl}`);
  };

  return (
    <PrimaryContainer backgroundColor={backgroundColor} style={additionals}>
      <ContainerXLPadding>
        <Row xs={1} md={2} className="mx-2 mx-md-0 h-100">
          <Col
            xs={(12, { order: "first" })}
            md={(6, { order: textOnLeft ? "last" : "first" })}
            className="d-flex align-items-center"
          >
            <ImageContent src={imageSrc} className="img-fluid" />
          </Col>
          <TextColumn
            xs={(12, { order: "last" })}
            md={(6, { order: textOnLeft ? "first" : "last" })}
          >
            <TextContent textOnLeft={textOnLeft}>
              <Subheading>{subheading}</Subheading>
              <Header>{heading}</Header>
              <Description>{description}</Description>
              {enableButton && (
                <PrimaryButton
                  buttonRounded={buttonRounded}
                  onClick={handleClick}
                  whileHover={{
                    scale: 1.3,
                  }}
                >
                  {primaryButtonText}
                </PrimaryButton>
              )}
            </TextContent>
          </TextColumn>
        </Row>
      </ContainerXLPadding>
    </PrimaryContainer>
  );
};

export default TwoColWithButton;
